export default [
  'M20 0C9 0 0 9 0 20s9 20 20 20 20-9 20-20S31 0 20 0zm0 2.7c9.6 0 17.3 7.8 17.3 17.3S29.6 37.3 20 37.3 2.7 29.6 2.7 20 10.4 2.7 20 2.7z',
  'M11.1 21.7c-.5.5-.5 1.2-.2 1.7l.2.2 5.3 5.3c.5.5 1.2.5 1.7.2l.2-.2 13.3-13.3c.5-.5.5-1.4 0-1.9s-1.2-.5-1.7-.2l-.2.2-12.4 12.4-4.4-4.4c-.5-.5-1.2-.5-1.7-.2l-.1.2z',
];
